// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1wDNZ","header":"MessagesList_header__2PCw2","chat":"MessagesList_chat__2py9h"};